export const getUserRole = user => {
  if (!user) return null

  if (user.is_admin || user.roles) {
    return user.roles?.[0]?.role || null
  }

  if (user.is_organization && Array.isArray(user.organizations)) {
    for (const org of user.organizations) {
      for (const group of org.organization_user?.organization_groups || []) {
        if (group.roles?.length) {
          return group.roles[0].role
        }
      }
    }
  }

  if (user.organization_groups?.length) {
    return user.organization_groups[0].roles?.[0]?.role || null
  }

  return null
}
